import { useTranslation } from "react-i18next";
import { Calendar } from "lucide-react";
import { format } from "date-fns";

interface OpportunityDeadlineProps {
  deadline: string | null;
}

export const OpportunityDeadline = ({ deadline }: OpportunityDeadlineProps) => {
  const { t } = useTranslation();
  
  if (!deadline) return null;

  return (
    <div className="flex items-center text-muted-foreground">
      <Calendar className="w-4 h-4 mr-2" />
      <span className="text-sm">
        {t('opportunityCard.deadline')}: {format(new Date(deadline), "MMM d, yyyy")}
      </span>
    </div>
  );
};